import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ModalConfirmacionViewModel } from './modal-confirmacion.view-model';


@Component({
    selector: 'sura-modal-confirmacion',
    templateUrl: './modal-confirmacion.component.html',
    styleUrls: ['./modal-confirmacion.component.scss'],
    standalone: false
})
export class ModalConfirmacionComponent {

    public modalconfirmacionViewModel: ModalConfirmacionViewModel = this.iniciarViewModel();
    public tituloVentana: string;
    public contenidoVentana: string;

    constructor(
        public dialogRef: DynamicDialogRef,
        public config: DynamicDialogConfig
    ) {
        this.tituloVentana = config.data.tituloVentana;
        this.contenidoVentana = config.data.contenidoVentana;
    }

    /**
     * Inicializa variables del view entity
     */
    private iniciarViewModel(): ModalConfirmacionViewModel {
        return new ModalConfirmacionViewModel(null,);
    }

    /**
     * Cancela y cierra el modal
     */
    public cancelar(): void {
        this.dialogRef.close(false);
    }

    /**
     * Acepta y cierra el modal
     */
    public aceptar(): void {
        this.dialogRef.close(true);
    }
}
